import { TableCols } from "../interfaces/static-data";

export const TARGET_MARKETS: TableCols[] = [
  {
    key: 'payoff',
    displayValue: 'Payoff',
    type: 'select'
  },
  {
    key: 'basic_advised',
    displayValue: 'Basic Advised',
  },
  {
    key: 'basic_non_advised',
    displayValue: 'Basic Non-Advised',
  },
  {
    key: 'informed_advised',
    displayValue: 'Informed Advised',
  },
  {
    key: 'informed_non_advised',
    displayValue: 'Informed Non-Advised',
  },
  {
    key: 'sophisticated_advised',
    displayValue: 'Sophisticated Advised',
  },
  {
    key: 'sophisticated_non_advised',
    displayValue: 'Sophisticated Non-Advised',
  },
  {
    key: 'professional_advised',
    displayValue: 'Professional Advised',
  },
  {
    key: 'professional_non_advised',
    displayValue: 'Professional Non-Advised',
  },
  {
    key: 'basicMarketNeed',
    displayValue: 'Basic Market Need',
  },
  {
    key: 'informedMarketNeed',
    displayValue: 'Informed Market Need',
  },
  {
    key: 'sophisticatedMarketNeed',
    displayValue: 'Sophisticated Market Need',
  },
  {
    key: 'revisionDate',
    displayValue: 'Revision Date',
    mask: '0000-00-00',
  },
  {
    key: 'notes',
    displayValue: 'Notes',
  },
];
